var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-list',_vm._l((10),function(n){return _c('ion-item',{key:n,staticClass:"ion-text-wrap",attrs:{"detail":"false"}},[_c('div',{staticClass:"shimmer-item-container"},[_c('div',{staticClass:"shimmer-box title-line-shimmer"}),_c('div',{staticClass:"shimmer-box subtitle-line-shimmer"})])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }